var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect } from 'react';
export var useDebouncedEffect = function (effect, delay, deps) {
    var callback = useCallback(effect, __spreadArray([effect], deps, true));
    useEffect(function () {
        var handler = setTimeout(function () {
            callback();
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [callback, delay]);
};
//# sourceMappingURL=index.js.map